import { render, staticRenderFns } from "./FullScreenButton.vue?vue&type=template&id=ebf91ee0&scoped=true&"
import script from "./FullScreenButton.vue?vue&type=script&lang=js&"
export * from "./FullScreenButton.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenButton.vue?vue&type=style&index=0&id=ebf91ee0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf91ee0",
  null
  
)

component.options.__file = "FullScreenButton.vue"
export default component.exports